import { render, staticRenderFns } from "./GradeOtherItemForm.vue?vue&type=template&id=1caffa91"
import script from "./GradeOtherItemForm.vue?vue&type=script&lang=js"
export * from "./GradeOtherItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports